<template>
<div class="personal">
    <el-dialog
        :title="$t('personal.title')"
        :visible="openPersonal"
        :close-on-click-modal="false"
        :show-close="true"
        width="340px"
        @close="clearValidate">
        <div class="formbox">
            <el-form :model="formData" :rules="rules" ref="form" :label-width="labW" class="perform">
                <el-form-item :label="$t('personal.name')">
                   {{name}}
                </el-form-item>
                <el-form-item :label="$t('personal.inp1')" prop="input1">
                    <el-input type="password" v-model.trim="formData.input1" :placeholder="$t('personal.pl1')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('personal.inp2')" prop="input2">
                    <el-input type="password" v-model.trim="formData.input2" :placeholder="$t('personal.pl2')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('personal.inp3')" prop="input3">
                    <el-input type="password" v-model.trim="formData.input3" :placeholder="$t('personal.pl3')"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="clearValidate">{{$t("common.btnUsual")}}</el-button>
            <el-button type="primary" :loading="btnLoading" @click="submit">{{$t("common.btnPrimary")}}</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import { Mixins } from '@/config/mixins/mixins'
import { $http } from '@/config/api/axios'
export default { 
    name:'personal',
    mixins:[Mixins],
    props:{
        openPersonal:{
            type:Boolean,
            default:false
        }
    },
    data(){
        // var validatePass = (rule,value,callback) =>{
        //     let  regexp = /[\u4e00-\u9fa5]+/  ///[^\u4e00-\u9fa5a-zA-Z\d,\.，。]+/ 
        //     if (regexp.test(value)) {
        //         callback(new Error('输入的密码不能包含汉字'));
        //     } else {
        //         callback();
        //     }
        // }
        return{
            labW:"100px",
            btnLoading:false,
            name:'',
            formData:{
                input1:'',
                input2:'',
                input3:'',
            },
            rules:{
                input1:[
                    {required: true, message: this.$t('personal.pl1'), trigger: 'blur'},
                ],
                input2:[
                    {required: true, message: this.$t('personal.pl2'), trigger: 'blur'},
                    {pattern: /^(?=.*[0-9].*)(?=.*[a-zA-Z].*).{6,16}$/, message: this.$t('personal.valid'), trigger: 'blur'},
                    {pattern: /^[0-9a-zA-Z]*$/g, message: this.$t('personal.valid'), trigger: 'blur'},
                ],
                input3:[
                    {required: true, message: this.$t('personal.pl3'), trigger: 'blur'},
                    {pattern: /^(?=.*[0-9].*)(?=.*[a-zA-Z].*).{6,16}$/, message: this.$t('personal.valid'), trigger: 'blur'},
                    {pattern: /^[0-9a-zA-Z]*$/g, message: this.$t('personal.valid'), trigger: 'blur'},
                ],
            },
        }
    },
    methods:{
        submit(){
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    let userInfo = JSON.parse(localStorage.getItem('tokenUser'))
                    $http("post", "/user/changePwd",{
                        userId:userInfo.tokenUserId,
                        originalPwd:this.formData.input1,
                        newPwd:this.formData.input2,
                        repeatPwd:this.formData.input3,
                    }).then((res)=>{
                        this.btnLoading = false;
                        if(res.status === "SUCCESS"){
                            this.msgsuccess(res.message)
                            this.$emit('update:openPersonal',false)
                        }else{
                            this.msgerror(res.message)
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        clearValidate(){
            this.$refs['form'].clearValidate()
            this.$emit('update:openPersonal',false)
        },
    },
    watch:{
        openPersonal(bool){
            if(bool){
                let userInfo = JSON.parse(localStorage.getItem('tokenUser'))
                this.name = userInfo.tokenUserName;
                this.formData.input1 = "";
                this.formData.input2 = "";
                this.formData.input3 = "";
            }
        }
    },
    created(){
        if(this.$i18n.locale === "zh"){
            this.labW = "90px"
        }
    },
}
</script>

<style lang="less" scoped>
.personal{
    .formbox{
        word-break: break-word;
    }
    /deep/.el-dialog__body{
        padding-bottom: 0;
    }
}
</style>